export default "__VITE_ASSET__71f67873__"